import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/contact.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/core-expertise.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/Home/AvailableFor/AvailableFor.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/Home/Book/book.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/Home/CommunityTree/CommunityTree.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/Home/LinkedInSocialProof/LinkedInSocialProof.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/Home/RecognizedBy/RecognizedBy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/scroll-progress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/simple-hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/buildhome/repo/node_modules/.pnpm/next@15.5.12_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/next@15.5.12_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/next@15.5.12_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
